import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-flow: column;
  position: relative;
  height: 95%;

  hr {
    margin: 15px 0 10px 0;
    border: 1px solid ${props => props.theme.colors.color6b7786};
  }
`

export const ContainerInformation = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  flex-flow: column;
  flex: 1 1 auto;

  overflow-y: scroll;

  ${VerticalStyledScrollBar}
`

export const AnchorLinkToExamDetails = styled.a`
  height: 40px;
  padding: 0 10px;
  border: none;
  color: ${({ theme }) => theme.zds.colors.neutral1000};
  font: normal normal medium 14px/21px Inter;
  margin-right: 8px;
  cursor: pointer;
  background: ${props => props.theme.colors.color378ff7} 0% 0% no-repeat padding-box;
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
    stroke: ${({ theme }) => theme.zds.colors.neutral1000};
    stroke-width: 1px;
    width: 20px;
    height: 17px;
    margin-right: 8px;
  }

  &:hover {
    background: ${props => props.theme.colors.color257ce5} 0% 0% no-repeat padding-box;
  }
`
